import React from "react";
import product from "../assets/product.png";
import heart from "../assets/heart.png";
import { HeartFilled, PlusOutlined } from "@ant-design/icons";
import { toggleFavorite } from "../redux/ecommerce/favoriteSlice";
import { useDispatch, useSelector } from "react-redux";
 import { useState } from 'react';
import { message } from "antd";

const Product2 = ({id}) => {
    const [isFavorite, setIsFavorite] = useState(false);
  const dispatch = useDispatch();

    const handleToggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation(); 

    const newStatus = isFavorite ? "no" : "yes";

    try {
      await dispatch(
        toggleFavorite({
          eco_products_id: id,
          status: newStatus, 
        })
      ).unwrap();
      setIsFavorite(!isFavorite);
      message.success(isFavorite ? "تمت الإزالة من المفضلة" : "تمت الإضافة للمفضلة");
    } catch (error) {
      console.error("Error toggle favorite:", error);
      message.error("حدث خطأ أثناء تعديل المفضلة.");
    }
  };
  return (
    <div className="bg-[#172e57] rounded-3xl px-7 pt-4 pb-7">
      <div className="relative">
        <img
          src={product}
          className="rounded-3xl w-[250px] h-[220px] mx-auto"
        />
        <div 
          onClick={handleToggleFavorite}
          className="bg-[#FCFBFA] w-[40px] h-[40px] mx-auto flex items-center justify-center rounded-full absolute top-5 right-8 cursor-pointer hover:bg-gray-100 transition text-[#fe6625]"
        >
          {isFavorite ? (
            <HeartFilled className="text-xl" />
          ) : (
            <img src={heart} className="w-[19px]" alt="favorite" />
          )}
        </div>
      </div>
      <div className="flex items-center justify-between px-3 mt-4">
        <div>
          <p className="text-[#F3F5F7]">Cage Lamp</p>
          <p className="text-[#DDE5ED] font-semibold text-xl">1546 SR</p>
        </div>
        <button className="bg-[#FE9B71] text-white flex items-center px-7 py-2 rounded-full font-semibold">
          Add <PlusOutlined className="ml-4" />
        </button>
      </div>
    </div>
  );
};

export default Product2;
